import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetPrivacyStatementResponse extends BackendResponse {
  item: PrivacyStatement;
}

export const getPrivacyStatement = withNextApi<GetPrivacyStatementResponse>(
  "/cvp/CvpGetPrivacyStatement",
  { method: "GET" }
);

export interface PrivacyStatement {
  statementHtml: string;
  statement: string;
  concernOverriddenStatement: string;
  concernOverriddenStatementLanguageId: string;
  allLanguageStatements: IdContentObject[];
}

export interface IdContentObject {
  id: string;
  content: string;
}
